import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import APLogo from '@alphapoint/apex-web/lib/components/common/APLogo/APLogo';
import PageHeaderNavComponent from '../../components/PageHeader/PageHeaderNavComponent';
import UserSummaryContainer from '../../components/UserSummary/UserSummaryContainer';
import AccountsDropdownContainer from '../../components/AccountsDropdown/AccountsDropdownContainer';
import './PageHeaderLayout.css';
import './UserSummaryOverrides.css';
import Link from '../../components/common/Link';
import { ThemeToggler } from '@alphapoint/apex-web/lib/components/Theme/ThemeToggler/ThemeToggler';
import LanguageSelectorContainer from '@alphapoint/apex-web/lib/components/Language/LanguageSelectorContainer';
import APButton from '@alphapoint/apex-web/lib/components/common/APButton';
import config from '../../config';
import {
  marginSystemEnabledSelector,
  marginBorrowerEnabledSelector,
} from '@alphapoint/apex-web/lib/redux/margin/selectors/marginSelectors';

const pageHeaderClasses = getBEMClasses('page-header');

const PageHeaderComponent = ({ isAuthenticated, systemMarginEnabled, marginBorrowerEnabled }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const mainNavItems = useMemo(() => config.Navigation.menuNavigationItems, []);

  return (
    <React.Fragment>
      <div className={pageHeaderClasses('container')}>
        <div className={pageHeaderClasses('content-wrapper')}>
          <div className={pageHeaderClasses('header-item', 'logo')}>
            <APLogo customClass={pageHeaderClasses('logo')} linkTo="/" />
          </div>
          <PageHeaderNavComponent navItems={mainNavItems} />
          <div className={pageHeaderClasses('right-panel')}>
            {isAuthenticated && systemMarginEnabled && !marginBorrowerEnabled && (
              <APButton
                onClick={() => history.push('/settings/trade')}
                classModifiers={pageHeaderClasses('enable-margin')}
                type="button">
                {t('Enable Margin Trading', { ns: 'margin' })}
              </APButton>
            )}
            <ThemeToggler />
            <LanguageSelectorContainer />
            {isAuthenticated ? (
              <>
                <UserSummaryContainer customClass="page-header-user-summary" settingsRoute="/settings/user" />
                <AccountsDropdownContainer customClass="page-header-accounts-dropdown" />
              </>
            ) : (
              <div className={pageHeaderClasses('login-content-wrapper')}>
                <Link href={'/login'} className={pageHeaderClasses('login-link')}>
                  <span className="text">{t('Login')}</span>
                  <span className="icon">
                    <svg width="19" height="7" viewBox="0 0 19 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.4049 3.78168V6.5403L18.2874 3.32191L14.4049 0.103516V2.86214H0.816089V3.78168H14.4049Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ auth: { isAuthenticated }, ...state }) => ({
  isAuthenticated,
  systemMarginEnabled: marginSystemEnabledSelector(state),
  marginBorrowerEnabled: marginBorrowerEnabledSelector(state),
});

export default withRouter(connect(mapStateToProps)(PageHeaderComponent));
